import React from "react";
import "../../styles/ClaimDetailsPage.scss";
import PolicyInformation from "../policy-information/PolicyInformation";
import ContractHolder from "../contract-holder/ContractHolder";
import VehicleDetails from "../vehicle-details/VehicleDetails";
import LienHolder from "../lien-holder/LienHolder";
import SellingDealer from "../selling-dealer/SellingDealer";
import ClaimHeader from "../claim-header/ClaimHeader";
import ClaimStatusSummary from "../claim-status-summary/ClaimStatusSummary"
import ClaimActivity from "../claim-activity/ClaimActivity"
import ClaimDocument from "../claim-documents/ClaimDocument"
const ClaimDetailsPage = (props) => {
    const { claimData, claimSummaryData, claimDocuments } = props;
    const [isFoundAttechment, setFoundAttechment] = React.useState(false);

    const checkAttechmentData = () => {
        const result = claimDocuments?.some((document)=> document?.attachmentData?.attachments?.length > 0);
        setFoundAttechment(result);
    }

    React.useEffect(()=>{
        checkAttechmentData();
        // checkAttechmentData reads claimDocuments prop; existing behavior runs once on mount.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const displayData = () => {
        if (claimData) {
            const { customer, vehicle, seller, lien } = claimData;
            return (
                <section className="banner-section">
                    <div className="container claim-container">
                        <ClaimHeader claimText="My Claim" />

                        <div className="main-row">
                            <div className="col-lg">
                                <ClaimStatusSummary isFoundAttechment={isFoundAttechment} summaryData={claimSummaryData && claimSummaryData} />
                                <ClaimActivity activityData={claimSummaryData && claimSummaryData?.notes} />
                                <ContractHolder direction="row" contractHolderData={customer && customer} />
                                <PolicyInformation direction="row" policyInformationData={claimData && claimData} />
                                <VehicleDetails direction="row" vehicleDetailsData={vehicle && vehicle} />
                                <SellingDealer direction="column" sellingDealerData={seller && seller} />
                                <LienHolder direction="column" lienHolderData={lien && lien} />
                            </div>
                            <div className="col-lg">
                                <ClaimDocument claimDocuments={claimDocuments} claimNumber={claimSummaryData && claimSummaryData.claimNumber} claimId={claimSummaryData && claimSummaryData.claimId}/>
                            </div>
                        </div>
                    </div>
                </section>)
        }
    }
    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

export default ClaimDetailsPage;